import EmployeeEmploymentComponents from "../components/EmployeeEmployment";
import useEmployeeEmployment from "../hooks/useEmployeeEmployment";

function EmployeeEmployment() {
  const employeeEmploymentProps = useEmployeeEmployment();
  return <EmployeeEmploymentComponents {...employeeEmploymentProps} />;
}

export default EmployeeEmployment;
